import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=72a457e0&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=72a457e0&lang=stylus&scoped=true&"
import style1 from "./Product.vue?vue&type=style&index=1&lang=stylus&"
import style2 from "./Product.vue?vue&type=style&index=2&id=72a457e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a457e0",
  null
  
)

export default component.exports